import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import EcoIndex from "./EcoIndex";
// import htmlDocx from "html-docx-js/dist/html-docx";
// import { saveAs } from "file-saver";
import EventDetailsSidebar from "./eventDetailsSidebar";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
import { useEvent } from "./EventDetailsContext";
import "./Report.css";
import EventName from "./EventName";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import { saveAs } from "file-saver";
import PreviewReport from "./previewReport";
import ScopeEmissionDoughnutChart from "./ScopeEmissionDoughnutChart";
import {
  getEmissionPreEventActivity,
  getEmissionDuringEventActivity,
  getEmissionPostEventActivity,
  getDashboardData,
  isAttendeeDetailsInitiated,
  GetEnergyConsumptionList,
} from "./apiService";
import homePic from "./assets/home-pic.jpg";
import sproutImg from "./assets/sprout.png";
import DoughnutChart from "./DoughnutChart";
import DoughnutChart2 from "./DoughnutChart2";
import DoughnutChart3 from "./DoughnutChart3";
import TravelModeDoughnutChart from "./AttendeeTravelChart";
import MealConsumptionDoughnutChart from "./attendeeMealChart";
import CustomAlert from "./CustomAlert";
import { width } from "@fortawesome/free-solid-svg-icons/fa0";
import { getReport, saveReport } from "./apiService";
import Cropper from "react-easy-crop";
import getCroppedImg from "./utils/getCroppedImg.js";
const travelModeMappings = {
  1: "Car-Diesel",
  2: "Car-Petrol",
  3: "Car-CNG",
  4: "Car-Electric",
  46: "Car-Hybrid",
  5: "Bus-Fuel-Based",
  6: "Train-Train",
  7: "Bus-Electric",
  8: "Flight-Economy",
  13: "Flight-Business",
  47: "2-Wheeler-Petrol",
  48: "2-Wheeler-EV",
  49: "2-Wheeler-Diesel",
  50: "3-Wheeler-Petrol",
  52: "3-Wheeler-Diesel",
  51: "3-Wheeler-CNG",
  54: "Car-Pool-Petrol",
  53: "Car-Pool-Diesel",
  55: "Car-Pool-CNG",
  56: "Car-Pool-EV",
  45: "Car-Pool-Hybrid",
  42: "Metro-Electric",
};

const Report = () => {
  const location = useLocation();
  const { eventDetails, setEventDetails } = useEvent();
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [preEventData, setPreEventData] = useState([]);
  const [duringEventData, setDuringEventData] = useState([]);
  const [postEventData, setPostEventData] = useState([]);
  const [totalEstimatedCarbonEmission, setTotalEstimatedCarbonEmission] =
    useState(null);
  const [attendeeDetails, setAttendeeDetails] = useState([]);
  const [energyConsumptionData, setEnergyConsumptionData] = useState([]);
  const [wasteGeneration, setWasteGeneration] = useState("0.00");
  const [detailedData, setDetailedData] = useState([]);
  const reportRef1 = useRef();
  const reportRef2 = useRef();
  const reportRef3 = useRef();
  const reportRef4 = useRef();
  const reportRef5 = useRef();
  const reportRef6 = useRef();
  const reportRef7 = useRef();
  const reportRef8 = useRef();
  const reportRef9 = useRef();
  const reportRef10 = useRef();
  const reportRef11 = useRef();
  const reportRef12 = useRef();
  const reportRef13 = useRef();
  const reportRef14 = useRef();
  const reportRef15 = useRef();
  const reportRef16 = useRef();
  const scopeChartRef = useRef(null);
  const TravelChartRef = useRef(null);
  const preEventChartRef = useRef(null);
  const duringEventChartRef = useRef(null);
  const postEventChartRef = useRef(null);
  // const [isPDF, setIsPDF] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [isLoading, setIsLoading] = useState(true);
  const [eventType, setEventType] = useState("");
  const [eventName, setEventName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [eventLocation, setEventLocation] = useState("");

  useEffect(() => {
    if (location.state?.event) {
      setEventDetails(location.state.event);
      setIsLoading(false);
    }
  }, [location.state, setEventDetails]);

  const [conclusionText, setConclusionText] = useState("");

  // const handleDownloadPDF = () => {
  //   const refs = [
  //     reportRef1,
  //     reportRef2,
  //     reportRef3,
  //     reportRef4,
  //     reportRef5,
  //     reportRef6,
  //     reportRef7,
  //     reportRef8,
  //     reportRef9,
  //     reportRef10,
  //     reportRef11,
  //     reportRef12,
  //     reportRef13,
  //     reportRef14,
  //     reportRef15,
  //     reportRef16,
  //   ];

  //   setIsPDF(true);

  //   const noPdfElements = document.querySelectorAll(".no-pdf");
  //   const originalStyles = new Map();

  //   const applyDisplayStyle = (element, displayStyle) => {
  //     const computedStyle = window.getComputedStyle(element);
  //     const currentDisplay = computedStyle.display;
  //     originalStyles.set(element, { display: currentDisplay });
  //     element.style.display = displayStyle;
  //   };

  //   const restoreOriginalDisplayStyles = () => {
  //     originalStyles.forEach((styles, element) => {
  //       Object.assign(element.style, styles);
  //     });
  //   };

  //   noPdfElements.forEach((el) => applyDisplayStyle(el, "none"));

  //   const hideEmptyHighlights = () => {
  //     const highlights = document.querySelectorAll(".editableField");
  //     const hiddenHighlights = [];

  //     highlights.forEach((highlight) => {
  //       if (
  //         highlight.value === "---Add Highlight---" ||
  //         highlight.value.trim() === ""
  //       ) {
  //         const liElement = highlight.closest("li");
  //         if (liElement) {
  //           applyDisplayStyle(liElement, "none");
  //           hiddenHighlights.push(liElement);
  //         }
  //       }
  //     });

  //     return hiddenHighlights;
  //   };

  //   const hideEmptyImageSections = () => {
  //     const elementsToHide = [];
  //     const selectors = [".ImgWrp", ".ImgWrp1"];
  //     const imageSections = document.querySelectorAll(selectors.join(","));
  //     const hiddenSections = [];

  //     imageSections.forEach((section) => {
  //       const imgElement = section.querySelector("img");
  //       const inputField = section.querySelector("input.editableText");
  //       const isImageUploaded =
  //         imgElement &&
  //         imgElement.src &&
  //         !imgElement.src.includes("data:image/gif"); // skip blank placeholders
  //       const isTitleEdited = inputField && inputField.value.trim() !== "";

  //       if (!isImageUploaded) {
  //         applyDisplayStyle(section, "none");
  //         hiddenSections.push(section);
  //       }
  //       if (inputField && !isTitleEdited) {
  //         const textWrapper = inputField.closest(".textWrp");
  //         if (textWrapper) {
  //           applyDisplayStyle(textWrapper, "none");
  //           hiddenSections.push(textWrapper);
  //         }
  //       }
  //     });

  //     return hiddenSections;
  //   };

  //   const hideEmptyTextSections = () => {
  //     const textBlocks = document.querySelectorAll(
  //       ".editableParagraph, .editableTextBlock"
  //     );
  //     const hiddenSections = [];

  //     textBlocks.forEach((block) => {
  //       const textContent = block.innerText || block.textContent;
  //       if (!textContent || textContent.trim() === "") {
  //         applyDisplayStyle(block, "none");
  //         hiddenSections.push(block);
  //       }
  //     });

  //     return hiddenSections;
  //   };

  //   const increaseFontSize = (ref) => {
  //     const elements = ref.querySelectorAll(
  //       "p:not(.no-font-size-change):not(.no-pdf), " +
  //         "span:not(.no-font-size-change):not(.no-pdf), " +
  //         "td:not(.no-font-size-change):not(.no-pdf), " +
  //         "th:not(.no-font-size-change):not(.no-pdf), " +
  //         "tr:not(.no-font-size-change):not(.no-pdf), " +
  //         "i:not(.no-pdf)"
  //     );

  //     const fontSizes = new Map();

  //     elements.forEach((element) => {
  //       const computedStyle = window.getComputedStyle(element);
  //       fontSizes.set(element, {
  //         fontSize: computedStyle.fontSize,
  //       });
  //       element.style.fontSize =
  //         parseFloat(computedStyle.fontSize) * 1.5 + "px";

  //       // Center-align content in table headers and cells
  //       if (["td", "th"].includes(element.tagName)) {
  //         element.style.textAlign = "center";
  //         element.style.verticalAlign = "middle";
  //         element.style.marginTop = "-10px";
  //       }
  //     });

  //     return fontSizes;
  //   };

  //   const resetFontSize = (fontSizes) => {
  //     fontSizes.forEach((styles, element) => {
  //       Object.assign(element.style, styles);
  //     });
  //   };

  //   const pdf = new jsPDF("p", "mm", "a4");

  //   const generatePDF = (index = 0) => {
  //     if (index >= refs.length) {
  //       restoreOriginalDisplayStyles();
  //       setIsPDF(false);
  //       pdf.save("report.pdf");
  //       return;
  //     }

  //     const ref = refs[index]?.current;
  //     if (!ref) {
  //       generatePDF(index + 1);
  //       return;
  //     }

  //     const currentMargin = index === 0 ? 0 : 5;

  //     const fontSizes = increaseFontSize(ref);
  //     const hiddenHighlights = hideEmptyHighlights();
  //     const hiddenImageSections = hideEmptyImageSections();
  //     const hiddenTextSections = hideEmptyTextSections();

  //     html2canvas(ref, { backgroundColor: "#ffffff", scale: 2 }).then(
  //       (canvas) => {
  //         const ctx = canvas.getContext("2d");
  //         const imageData = ctx.getImageData(
  //           0,
  //           0,
  //           canvas.width,
  //           canvas.height
  //         ).data;

  //         let whitePixels = 0;
  //         for (let i = 0; i < imageData.length; i += 4) {
  //           const r = imageData[i];
  //           const g = imageData[i + 1];
  //           const b = imageData[i + 2];
  //           const a = imageData[i + 3];

  //           if (r > 250 && g > 250 && b > 250 && a > 250) {
  //             whitePixels++;
  //           }
  //         }

  //         const totalPixels = canvas.width * canvas.height;
  //         const whiteRatio = whitePixels / totalPixels;

  //         resetFontSize(fontSizes);
  //         [
  //           ...hiddenHighlights,
  //           ...hiddenImageSections,
  //           ...hiddenTextSections,
  //         ].forEach((element) => {
  //           element.style.display = originalStyles.get(element)?.display || "";
  //         });

  //         if (whiteRatio < 0.98) {
  //           const imgData = canvas.toDataURL("image/png");
  //           const pdfWidth =
  //             pdf.internal.pageSize.getWidth() - 2 * currentMargin;
  //           const aspectRatio = canvas.height / canvas.width;
  //           const pdfHeight = pdfWidth * aspectRatio;

  //           if (index !== 0) {
  //             pdf.addPage();
  //           }

  //           pdf.addImage(
  //             imgData,
  //             "PNG",
  //             currentMargin,
  //             currentMargin,
  //             pdfWidth,
  //             pdfHeight
  //           );
  //         }

  //         generatePDF(index + 1);
  //       }
  //     );
  //   };
  //   generatePDF();
  // };
  // ------------------- START INSERT handleDownloadWord HERE -------------------
  const handleDownloadWord = async () => {
    const templateUrl = "/report-template.docx";

    // 1) Fetch the .docx template from the public folder
    let templateArrayBuffer;
    try {
      const response = await fetch(templateUrl);
      if (!response.ok) {
        throw new Error("Could not load Word template at " + templateUrl);
      }
      templateArrayBuffer = await response.arrayBuffer();
    } catch (err) {
      console.error("Error fetching template:", err);
      return;
    }

    // 2) Initialize PizZip and Docxtemplater
    const zip = new PizZip(templateArrayBuffer);

    // 3) Configure the image module (for {%logo}, {%image1}, etc.)
    // const imageOpts = {
    //   getImage: (tagValue) => {
    //     // tagValue is "data:image/png;base64,..." → strip prefix:
    //     const base64String = tagValue.split(";base64,")[1];
    //     const binary = atob(base64String);
    //     const u8arr = new Uint8Array(binary.length);
    //     for (let i = 0; i < binary.length; i++) {
    //       u8arr[i] = binary.charCodeAt(i);
    //     }
    //     return u8arr;
    //   },
    //   getSize: (img, tagValue, tagName) => {
    //     // Return [widthInPoints, heightInPoints]; e.g. 150×150
    //     return [150, 150];
    //   },
    // };
    const imageOpts = {
      getImage: (tagValue) => {
        // tagValue is exactly whatever you passed into data.image1, e.g.
        // "data:image/jpeg;base64,/9j/4AAQSk…"
        const base64Parts = tagValue.split(";base64,");
        if (base64Parts.length !== 2) {
          // If the string wasn't in the expected "data:…;base64,XXXXX" format,
          // we can't decode it. Return an empty Uint8Array to avoid crashing.
          console.error("Invalid image data for placeholder:", tagValue);
          return new Uint8Array();
        }
        const rawBase64 = base64Parts[1]; // everything after "base64,"
        // Decode base64 into a binary string
        const binaryString = atob(rawBase64);
        // Convert binary string to UInt8 array
        const arr = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          arr[i] = binaryString.charCodeAt(i);
        }
        return arr;
      },
      getSize: (img /* not used here */, tagValue, tagName) => {
        // img is unused for our simple case; tagName is "image1", "image2", etc.
        // Return [width, height] in Word points. Adjust these to taste.
        // For example, make each image roughly 200×200 points:
        if (
          tagName === "preEventChart" ||
          tagName === "duringEventChart" ||
          tagName === "postEventChart" ||
          tagName === "scopeChart" ||
          tagName === "travelChart"
        ) {
          return [380, 270]; // 600 × 400 points for the breakdown doughnuts
        }
        if (tagName === "image1") {
          return [500, 350]; // width, height in points for image1
        }

        return [250, 190];
      },
    };
    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
      modules: [new ImageModule(imageOpts)],
    });
    let scopeChartBase64 = "";
    let travelChartBase64 = "";
    let preEventChartBase64 = "";
    let duringEventChartBase64 = "";
    let postEventChartBase64 = "";
    try {
      if (scopeChartRef.current?.toBase64Image) {
        scopeChartBase64 = scopeChartRef.current.toBase64Image();
      }
      if (TravelChartRef.current?.toBase64Image) {
        travelChartBase64 = TravelChartRef.current.toBase64Image();
      }
      if (preEventChartRef.current?.toBase64Image) {
        preEventChartBase64 = preEventChartRef.current.toBase64Image();
      }
      if (duringEventChartRef.current?.toBase64Image) {
        duringEventChartBase64 = duringEventChartRef.current.toBase64Image();
      }
      if (postEventChartRef.current?.toBase64Image) {
        postEventChartBase64 = postEventChartRef.current.toBase64Image();
      }
    } catch (err) {
      console.warn("Could not grab chart image:", err);
    }
    const scope1Fuel = emissionsData.scope1.fuelConsumption;
    const scope1Gas = emissionsData.scope1.gasConsumption;
    const scope1LPG = emissionsData.scope1.lpgConsumption;

    const scope2Elec = emissionsData.scope2.electricityConsumption;

    const scope3Marketing = emissionsData.scope3.marketingMaterial;
    const scope3PrintedInv = emissionsData.scope1.printedInvitations;
    const scope3EmailInv = emissionsData.scope1.invitationEmails;
    const scope3MatConsume = emissionsData.scope3.materialConsumption; // "0.0
    const scope3Travel = emissionsData.scope3.attendeeTravel; // "26.22"
    const scope3Accom = emissionsData.scope3.attendeeAccommodation; // "58.90"
    const scope3Meals = emissionsData.scope3.attendeeMeals; // "30.60"
    const scope3Waste = emissionsData.scope3.wasteGeneration; // "5.04"
    const scope3Shuttle = emissionsData.scope3.shuttleLocalTransport; // "0.00"
    const scope3Meetings = emissionsData.scope3.preEventMeetings;
    // 4) Build the `data` object to match your template placeholders:
    const emissionsTableRows = [
      {
        scope: "Scope 1 (Direct Emissions)",
        activity: "Fuel Consumption in DG Sets and Transportation",
        value: scope1Fuel,
      },
      { scope: "", activity: "Gas Consumption", value: scope1Gas },
      { scope: "", activity: "LPG Consumption", value: scope1LPG },

      {
        scope: "Scope 2 (Indirect Emissions)",
        activity: "Electricity Consumption",
        value: scope2Elec,
      },

      {
        scope: "Scope 3 (Indirect Emissions)",
        activity: "Marketing Material",
        value: scope3Marketing,
      },
      { scope: "", activity: "Printed Invitations", value: scope3PrintedInv },
      { scope: "", activity: "Invitation Emails", value: scope3EmailInv },
      { scope: "", activity: "Material Consumption", value: scope3MatConsume },
      { scope: "", activity: "Attendee Travel", value: scope3Travel },
      { scope: "", activity: "Attendee Accommodation", value: scope3Accom },
      { scope: "", activity: "Meals", value: scope3Meals },
      { scope: "", activity: "Waste Generation", value: scope3Waste },
      { scope: "", activity: "Shuttle/Local Transport", value: scope3Shuttle },
      { scope: "", activity: "Pre Event Meetings", value: scope3Meetings },
    ];
    const data = {
      // Single‐value text fields:
      eventName: eventName || eventDetails.eventName,
      eventLocation: eventLocation || formatLocation(eventDetails.location),
      startDate: startDate || formatDate(eventDetails.startDate),
      endDate:
        eventDetails.startDate !== eventDetails.endDate
          ? endDate || formatDate(eventDetails.endDate)
          : "",

      introPara1:
        introPara1 ||
        `The purpose of this assessment is to calculate the environmental impact of ${
          eventDetails.eventName
        }, held on ${formatDate(eventDetails.startDate)}${
          eventDetails.startDate !== eventDetails.endDate
            ? ` to ${formatDate(eventDetails.endDate)}`
            : ""
        } at ${formatLocation(
          eventDetails.location
        )} by evaluating its carbon footprint. Through this process, we aim to promote sustainability by identifying opportunities to reduce greenhouse gas emissions and enhance environmental stewardship within event management practices. The purpose of this report is to calculate the carbon footprint and establish a baseline that can serve as a reference for future events to reduce their carbon footprint.`,

      // If your template has a placeholder for "ABOUT THE EVENT" text, supply it here:
      sustainabilityPara:
        sustainabilityPara ||
        `${eventDetails.eventName} was designed with sustainability as a core focus, aiming to minimize its environmental impact while maximizing the positive outcomes for attendees. Through careful planning, we incorporated eco-friendly practices at every stage, from transportation and venue selection to catering and waste management. The organizing team was committed to reduce the event's carbon footprint and calculate the total impact of event on environment, and we are proud to present the calculated carbon emissions as part of our effort to promote transparency and continual improvement in sustainability practices.`,

      // 5) Loops for the three emission tables:
      prED: preEventData.map((item) => ({
        emissionType: item.emissionType,
        cmV: item.cumulativevalue.toFixed(2),
      })),
      dED: duringEventData.map((item) => ({
        emissionType: item.emissionType,
        cmV: item.cumulativevalue.toFixed(2),
      })),
      poED: postEventData.map((item) => ({
        emissionType: item.emissionType.replace("Quantity of", "").trim(),
        cmV: item.cumulativevalue.toFixed(2),
      })),
      participantCount: eventDetails.participantCount ?? 0,
      startDate: eventDetails.startDate
        ? formatDate(eventDetails.startDate)
        : "",

      totalEmission: emissionsData.totalEmission + " kgCO₂",
      roomsBooked: eventDetails.roomsBooked ?? 0,
      // 7) Scope breakdown (if your template uses emissionsByScope.scope1, etc.):
      scope1: (emissionsDataByScope["Scope 1 (Direct Emissions)"] || 0).toFixed(
        2
      ),
      scope2: (
        emissionsDataByScope["Scope 2 (Indirect Emissions)"] || 0
      ).toFixed(2),
      scope3: (
        emissionsDataByScope["Scope 3 (Indirect Emissions)"] || 0
      ).toFixed(2),

      // 8) Attendee travel loop (if your template uses {#attendeeTravelConsumptions}):
      aTCZ:
        attendeeDetails.attendeeTravelConsumptions?.map((item) => ({
          // look up the human-readable string. If the code isn't in the map, fall back to the raw code
          travelMode: travelModeMappings[item.travelModeId] ?? item.travelMode,
          count: item.attendeeCount,
        })) || [],
      emissionsTableRows,
      // 9) Image placeholders. Keys must match {%logo}, {%image1}, etc. in your template:
      // images: [
      //   { key: "logo", base64: uploadedLogo64 },
      //   { key: "image1", base64: image1Base64 },
      //   { key: "image2", base64: image2Base64 },
      //   { key: "image3", base64: image3Base64 },
      //   { key: "image4", base64: image4Base64 },
      //   { key: "image5", base64: image5Base64 },
      //   { key: "image6", base64: image6Base64 },
      //   { key: "image7", base64: image7Base64 },
      // If you also want to embed your Doughnut charts:
      // { key: "scopeChart", base64: scopeChartBase64 },
      // { key: "travelChart", base64: travelChartBase64 },
      // ],
      scopeChart: scopeChartBase64,
      travelChart: travelChartBase64,
      preEventChart: preEventChartBase64,
      duringEventChart: duringEventChartBase64,
      postEventChart: postEventChartBase64,
      logo: uploadedLogo64 || "",
      image1: image1Base64 || "",
      image2: image2Base64 || "",
      image3: image3Base64 || "",
      image4: image4Base64 || "",
      image5: image5Base64 || "",
      image6: image6Base64 || "",
      image7: image7Base64 || "",
      // 10) Captions or titles for each image, if your template uses {imageText1}, etc.:
      imageText1: textContent1 || "",
      imageText2: textContent2 || "",
      imageText3: textContent3 || "",
      imageText4: textContent4 || "",
      imageText5: textContent5 || "",
      imageText6: textContent6 || "",

      // 11) Conclusion (if your template has a {conclusionText} placeholder):
      conclusionText:
        conclusionText ||
        `${
          eventDetails.eventName || "Event Name"
        } team has taken significant steps to minimize the event's carbon footprint, implementing various strategies such as energy-efficient venue selection, promoting sustainable transportation options, and reducing waste. Despite these efforts, a total of ${(
          totalEstimatedCarbonEmission / 1000
        ).toFixed(
          0
        )} carbon credits are required to fully offset the residual emissions from the event. By purchasing these carbon credits, the team aims to neutralize their environmental impact, supporting projects that reduce or remove an equivalent amount of greenhouse gases from the atmosphere. This commitment underscores the event's dedication to sustainability and decarbonization.`,
      highlight1: highlight1 || "",
      highlight2: highlight2 || "",
      highlight3: highlight3 || "",
      highlight4: highlight4 || "",
    };
    console.log("image1Base64:", image1Base64?.slice(0, 30));
    console.log("attendeeTravelConsumptions", data.attendeeTravelConsumptionsZ);
    // 12) Set data on the Docxtemplater instance
    doc.setData(data);

    // 13) Render (this replaces all placeholders)
    try {
      doc.render();
    } catch (renderError) {
      console.error("Error rendering .docx template:", renderError);
      return;
    }

    // 14) Generate a Blob and trigger download
    const outBlob = doc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    saveAs(outBlob, "Carbon-Footprint-Report.docx");
  };
  // ------------------- END INSERT handleDownloadWord HERE -------------------

  const [naturalGasData, setNaturalGasData] = useState([]);
  const [lpgData, setLPGData] = useState([]);
  const attendeeTravelTotalEmission = duringEventData
    .filter((item) => item.emissionType === "Attendee Travel")
    .reduce((total, item) => total + item.value, 0);

  useEffect(() => {
    const fetchEmissionData = async () => {
      if (!eventDetails || !eventDetails.eventId) {
        console.log("Event details not available yet");
        return;
      }
      try {
        const preEventResponse = await getEmissionPreEventActivity(
          eventDetails?.eventId
        );
        setPreEventData(preEventResponse.mainData);

        const duringEventResponse = await getEmissionDuringEventActivity(
          eventDetails.eventId
        );

        const flattenedData = duringEventResponse.detailedData.flatMap((item) =>
          item.data.map((subItem) => ({
            emissionType: item.emissionType,
            emissionSubcategory: subItem.emissionSubcategory,
            value: subItem.value,
          }))
        );

        setDuringEventData(duringEventResponse.mainData);
        setDetailedData(flattenedData);

        const postEventResponse = await getEmissionPostEventActivity(
          eventDetails.eventId
        );
        setPostEventData(postEventResponse.mainData);
        console.log("Post event data: ", postEventData);

        if (postEventResponse && postEventResponse.mainData) {
          const totalWasteEmission = postEventResponse.mainData.reduce(
            (acc, item) => {
              const value = parseFloat(item.cumulativevalue) || 0;
              return acc + value;
            },
            0
          );

          setWasteGeneration(totalWasteEmission.toFixed(2));
        } else {
          console.log("postEventResponse or mainData is missing or undefined");
        }

        const dashboardResponse = await getDashboardData(eventDetails.eventId);
        setTotalEstimatedCarbonEmission(
          dashboardResponse.totalEstimatedCarbonEmission
        );

        const attendeeResponse = await isAttendeeDetailsInitiated(
          eventDetails.eventId
        );
        console.log("Full Attendee Response:", attendeeResponse);

        if (attendeeResponse && attendeeResponse.attendee) {
          setAttendeeDetails(attendeeResponse.attendee);
          console.log("Attendee Details:", attendeeResponse.attendee);
        } else {
          console.log("No Attendee Details found.");
        }

        const energyConsumptionResponse = flattenedData.filter(
          (item) => item.emissionType === "Energy Consumption"
        );

        setEnergyConsumptionData(energyConsumptionResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (eventDetails && eventDetails.eventId) {
      fetchEmissionData();
    }
  }, [eventDetails?.eventId]);

  //Electricity Consumption
  const [image1Base64, setImage1Base64] = useState(null);
  const [image2Base64, setImage2Base64] = useState(null);
  const [image3Base64, setImage3Base64] = useState(null);
  const [image4Base64, setImage4Base64] = useState(null);
  const [image5Base64, setImage5Base64] = useState(null);
  const [image6Base64, setImage6Base64] = useState(null);
  const [image7Base64, setImage7Base64] = useState(null);
  const [uploadedLogo64, setUploadedLogo64] = useState(null);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);
  const [image4, setImage4] = useState(null);
  const [image5, setImage5] = useState(null);
  const [image6, setImage6] = useState(null);
  const [image7, setImage7] = useState(null);
  const [uploadedLogo, setUploadedLogo] = useState(null);
  const [textContent1, setTextContent1] = useState("");
  const [textContent2, setTextContent2] = useState("");
  const [textContent3, setTextContent3] = useState("");
  const [textContent4, setTextContent4] = useState("");
  const [textContent5, setTextContent5] = useState("");
  const [textContent6, setTextContent6] = useState("");
  const [highlight1, setHighlight1] = useState("");
  const [highlight2, setHighlight2] = useState("");
  const [highlight3, setHighlight3] = useState("");
  const [highlight4, setHighlight4] = useState("");
  const [introPara1, setIntroPara1] = useState("");
  // const [introPara2, setIntroPara2] = useState("");
  const [sustainabilityPara, setSustainabilityPara] = useState("");
  const [methodologyPara1, setMethodologyPara1] = useState("");
  const [methodologyPara2, setMethodologyPara2] = useState("");
  const [editableEventDate, setEditableEventDate] = useState("");
  const [editableParticipantCount, setEditableParticipantCount] = useState("");
  const [editableRoomsBooked, setEditableRoomsBooked] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [image1File, setImage1File] = useState(null);
  const [showCropModal1, setShowCropModal1] = useState(false);
  const [crop1, setCrop1] = useState({ x: 0, y: 0 });
  const [zoom1, setZoom1] = useState(1);
  const [croppedAreaPixels1, setCroppedAreaPixels1] = useState(null);
  const [image2File, setImage2File] = useState(null);
  const [showCropModal2, setShowCropModal2] = useState(false);
  const [crop2, setCrop2] = useState({ x: 0, y: 0 });
  const [zoom2, setZoom2] = useState(1);
  const [croppedAreaPixels2, setCroppedAreaPixels2] = useState(null);
  const [image3File, setImage3File] = useState(null);
  const [showCropModal3, setShowCropModal3] = useState(false);
  const [crop3, setCrop3] = useState({ x: 0, y: 0 });
  const [zoom3, setZoom3] = useState(1);
  const [croppedAreaPixels3, setCroppedAreaPixels3] = useState(null);
  const [image4File, setImage4File] = useState(null);
  const [showCropModal4, setShowCropModal4] = useState(false);
  const [crop4, setCrop4] = useState({ x: 0, y: 0 });
  const [zoom4, setZoom4] = useState(1);
  const [croppedAreaPixels4, setCroppedAreaPixels4] = useState(null);
  const [image5File, setImage5File] = useState(null);
  const [showCropModal5, setShowCropModal5] = useState(false);
  const [crop5, setCrop5] = useState({ x: 0, y: 0 });
  const [zoom5, setZoom5] = useState(1);
  const [croppedAreaPixels5, setCroppedAreaPixels5] = useState(null);
  const [image6File, setImage6File] = useState(null);
  const [showCropModal6, setShowCropModal6] = useState(false);
  const [crop6, setCrop6] = useState({ x: 0, y: 0 });
  const [zoom6, setZoom6] = useState(1);
  const [croppedAreaPixels6, setCroppedAreaPixels6] = useState(null);
  const [image7File, setImage7File] = useState(null);
  const [showCropModal7, setShowCropModal7] = useState(false);
  const [crop7, setCrop7] = useState({ x: 0, y: 0 });
  const [zoom7, setZoom7] = useState(1);
  const [croppedAreaPixels7, setCroppedAreaPixels7] = useState(null);
  const handleLogoUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // 1) size guard
    if (file.size > 500 * 1024) {
      setAlertMessage(
        "File size exceeds 500 KB. Please upload a smaller image."
      );
      setAlertType("danger");
      setShowAlert(true);
      return;
    }

    // 2) read file as Data-URL
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target.result;
      // 3) create an Image to inspect its natural dimensions
      const img = new Image();
      img.src = dataUrl;
      img.onload = () => {
        setUploadedLogo(dataUrl);
        setUploadedLogo64(dataUrl);
        setLogoFile(dataUrl);
        setShowCropModal(true);
      };
    };
    reader.readAsDataURL(file);

    // allow re-selecting the same file if needed
    event.target.value = "";
  };

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);
  const applyCrop = useCallback(async () => {
    try {
      const croppedDataUrl = await getCroppedImg(logoFile, croppedAreaPixels);
      setUploadedLogo(croppedDataUrl); // your existing state
      setUploadedLogo64(croppedDataUrl); // for Word export
      setShowCropModal(false);
    } catch (err) {
      console.error(err);
    }
  }, [logoFile, croppedAreaPixels]);
  const applyCrop1 = useCallback(async () => {
    try {
      const croppedDataUrl = await getCroppedImg(
        image1File,
        croppedAreaPixels1
      );
      setImage1(croppedDataUrl);
      setImage1Base64(croppedDataUrl);
    } catch (err) {
      console.error("Crop failed:", err);
    }
    setShowCropModal1(false);
  }, [image1File, croppedAreaPixels1]);
  const applyCrop2 = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(image2File, croppedAreaPixels2);
      setImage2(cropped);
      setImage2Base64(cropped);
    } catch (err) {
      console.error(err);
    }
    setShowCropModal2(false);
  }, [image2File, croppedAreaPixels2]);
  const applyCrop3 = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(image3File, croppedAreaPixels3);
      setImage3(cropped);
      setImage3Base64(cropped);
    } catch (err) {
      console.error(err);
    }
    setShowCropModal3(false);
  }, [image3File, croppedAreaPixels3]);
  const applyCrop4 = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(image4File, croppedAreaPixels4);
      setImage4(cropped);
      setImage4Base64(cropped);
    } catch (err) {
      console.error(err);
    }
    setShowCropModal4(false);
  }, [image4File, croppedAreaPixels4]);
  const applyCrop5 = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(image5File, croppedAreaPixels5);
      setImage5(cropped);
      setImage5Base64(cropped);
    } catch (err) {
      console.error(err);
    }
    setShowCropModal5(false);
  }, [image5File, croppedAreaPixels5]);
  const applyCrop6 = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(image6File, croppedAreaPixels6);
      setImage6(cropped);
      setImage6Base64(cropped);
    } catch (err) {
      console.error(err);
    }
    setShowCropModal6(false);
  }, [image6File, croppedAreaPixels6]);
  const applyCrop7 = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(image7File, croppedAreaPixels7);
      setImage7(cropped);
      setImage7Base64(cropped);
    } catch (err) {
      console.error(err);
    }
    setShowCropModal7(false);
  }, [image7File, croppedAreaPixels7]);
  const handleImageUpload1 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        const dataUrl = reader.result;
        setImage1Base64(base64String);
        setImage1(reader.result); // Set the image preview
        setImage1File(dataUrl); // feed the cropper
        setShowCropModal1(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };
  console.log("base 64", image1Base64);
  const handleImageUpload2 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        setImage2Base64(base64String);
        setImage2(reader.result); // Set the image preview
        setImage2File(reader.result);
        setShowCropModal2(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };

  const handleImageUpload3 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        setImage3Base64(base64String);
        setImage3(reader.result); // Set the image preview
        setImage3File(reader.result);
        setShowCropModal3(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };
  const handleImageUpload4 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        setImage4Base64(base64String);
        setImage4(reader.result); // Set the image preview
        setImage4File(reader.result);
        setShowCropModal4(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };
  const handleImageUpload5 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        setImage5Base64(base64String);
        setImage5(reader.result); // Set the image preview
        setImage5File(reader.result);
        setShowCropModal5(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };
  const handleImageUpload6 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        setImage6Base64(base64String);
        setImage6(reader.result); // Set the image preview
        setImage6File(reader.result);
        setShowCropModal6(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };
  const handleImageUpload7 = (event) => {
    const file = event.target.files[0];

    if (file) {
      // if (file.size > 500 * 1024) {
      //   // 500 KB
      //   setAlertMessage(
      //     "File size exceeds 500 KB. Please upload a smaller image."
      //   );
      //   setAlertType("success");
      //   setShowAlert(true);
      //   event.target.value = ""; // Reset input field
      //   return; // Exit the function if the file is too large
      // }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        setImage7Base64(base64String);
        setImage7(reader.result); // Set the image preview
        setImage7File(reader.result);
        setShowCropModal7(true);
      };

      reader.readAsDataURL(file);
    }

    // Reset input field so user can select the same image again
    event.target.value = "";
  };
  const onCropComplete1 = useCallback((_, pixels) => {
    setCroppedAreaPixels1(pixels);
  }, []);
  const onCropComplete2 = useCallback((_, pixels) => {
    setCroppedAreaPixels2(pixels);
  }, []);
  const onCropComplete3 = useCallback((_, pixels) => {
    setCroppedAreaPixels3(pixels);
  }, []);
  const onCropComplete4 = useCallback((_, pixels) => {
    setCroppedAreaPixels4(pixels);
  }, []);
  const onCropComplete5 = useCallback((_, pixels) => {
    setCroppedAreaPixels5(pixels);
  }, []);
  const onCropComplete6 = useCallback((_, pixels) => {
    setCroppedAreaPixels6(pixels);
  }, []);
  const onCropComplete7 = useCallback((_, pixels) => {
    setCroppedAreaPixels7(pixels);
  }, []);
  useEffect(() => {
    if (!eventDetails?.eventId) return;
    fetch(
      `https://eventtool-api.octodosolutions.com/api/Reports/${eventDetails.eventId}`
    )
      .then((res) => {
        if (res.status === 404) return null;
        if (!res.ok) throw new Error("Failed to load report");
        return res.json();
      })
      .then((report) => {
        if (!report) return;
        console.log("Reportg", report);
        setEventName(report.eventName);
        setStartDate(report.startDate.slice(0, 10));
        // setEndDate(report.EndDate.slice(0, 10));
        setEventLocation(report.eventLocation);
        setUploadedLogo(report.uploadedLogo64);
        setImage1Base64(report.image1Base64);
        setImage2Base64(report.image2Base64);
        setImage3Base64(report.image3Base64);
        setImage4Base64(report.image4Base64);
        setImage5Base64(report.image5Base64);
        setImage6Base64(report.image6Base64);
        setImage7Base64(report.image7Base64);
        setUploadedLogo64(report.uploadedLogo64);
        setUploadedLogo(report.uploadedLogo64);
        setImage1(report.image1Base64);
        setImage2(report.image2Base64);
        setImage3(report.image3Base64);
        setImage4(report.image4Base64);
        setImage5(report.image5Base64);
        setImage6(report.image6Base64);
        setImage7(report.image7Base64);
        setIntroPara1(report.introPara1);
        // setIntroPara2(report.introPara2);
        setSustainabilityPara(report.sustainabilityPara);
        setConclusionText(report.conclusionText);

        setEditableEventDate(report.editableEventDate);
        setEditableParticipantCount(report.editableParticipantCount);
        setEditableRoomsBooked(report.editableRoomsBooked);

        setHighlight1(report.highlight1);
        setHighlight2(report.highlight2);
        setHighlight3(report.highlight3);
        setHighlight4(report.highlight4);

        setTextContent1(report.textContent1);
        setTextContent2(report.textContent2);
        setTextContent3(report.textContent3);
        setTextContent4(report.textContent4);
        setTextContent5(report.textContent5);
        setTextContent6(report.textContent6);
      })
      .catch(console.error);
  }, [eventDetails?.eventId]);
  console.log("textContent1", textContent1);
  const handleSave = useCallback(() => {
    //This is for someone who is not changing anything in fields
    const EventId = eventDetails.eventId;
    const finalEventName = eventName.trim() || eventDetails.eventName;

    const finalStartDate =
      startDate.trim() ||
      new Date(eventDetails.startDate).toLocaleDateString("en-GB");

    const finalEndDate =
      endDate.trim() ||
      (eventDetails.startDate !== eventDetails.endDate
        ? new Date(eventDetails.endDate).toLocaleDateString("en-GB")
        : "");

    const locParts = formatLocation(eventDetails.location).split(",");
    const defaultLocation = `${locParts[0]} - ${locParts[1]}\n${locParts[2]}`;
    const finalLocation = eventLocation.trim() || defaultLocation;

    const defaultIntro1 = `The purpose of this assessment is to calculate the environmental impact of ${
      eventDetails.eventName
    }, held on ${new Date(eventDetails.startDate).toLocaleDateString("en-GB")}${
      eventDetails.startDate !== eventDetails.endDate
        ? ` to ${new Date(eventDetails.endDate).toLocaleDateString("en-GB")}`
        : ""
    } at ${formatLocation(
      eventDetails.location
    )} by evaluating its carbon footprint. Through this process, we aim to promote sustainability by identifying opportunities to reduce greenhouse gas emissions and enhance environmental stewardship within event management practices. The purpose of this report is to calculate the carbon footprint and establish a baseline that can serve as a reference for future events to reduce their carbon footprint.`;
    const defaultIntro2 = `The purpose of this report is to calculate the carbon footprint and establish a baseline that can serve as a reference for future events to reduce their carbon footprint.`;
    const finalIntro1 = introPara1.trim() || defaultIntro1;

    const defaultAbout = `${eventDetails.eventName} was designed with sustainability as a core focus, aiming to minimize its environmental impact while maximizing the positive outcomes for attendees. Through careful planning, we incorporated eco-friendly practices at every stage, from transportation and venue selection to catering and waste management. The organizing team was committed to reduce the event's carbon footprint and calculate the total impact of event on environment, and we are proud to present the calculated carbon emissions as part of our effort to promote transparency and continual improvement in sustainability practices.`;
    const finalAbout = sustainabilityPara.trim() || defaultAbout;

    const defaultMethod1 = `Calculating the carbon footprint of an event involves assessing all activities related to the event that contribute to greenhouse gas emissions. This includes direct emissions from energy consumption at the venue, indirect emissions from attendee and staff travel, accommodation, and waste management, as well as emissions from the production and disposal of materials used. Data on energy usage, transportation distances, waste generated, and other relevant factors are collected and multiplied by appropriate emission factors to convert them into carbon dioxide equivalents (CO2e). The total emissions from all sources are then aggregated to determine the event's overall carbon footprint. This information can be used to identify the largest sources of emissions, report on the environmental impact, and explore options for offsetting or reducing the event's carbon footprint.`;
    const defaultMethod2 = `For better understanding all activities has been divided in the Pre-Event, During Event and Post Event section so that monitoring of data and calculation became easy. This methodology enhanced the boundary of event as it includes emissions associated with pre-event planning also.`;
    const finalMethod1 = methodologyPara1.trim() || defaultMethod1;
    const finalMethod2 = methodologyPara2.trim() || defaultMethod2;
    const defaultConclusion = `${
      eventDetails.eventName
    } team has taken significant steps to minimize the event's carbon footprint, implementing various strategies such as energy-efficient venue selection, promoting sustainable transportation options, and reducing waste. Despite these efforts, a total of ${(
      totalEstimatedCarbonEmission / 1000
    ).toFixed(
      0
    )} carbon credits are required to fully offset the residual emissions from the event. By purchasing these carbon credits, the team aims to neutralize their environmental impact, supporting projects that reduce or remove an equivalent amount of greenhouse gases from the atmosphere. This commitment underscores the event's dedication to sustainability and decarbonization.`;
    const finalConclusion = conclusionText.trim() || defaultConclusion;

    const defaultDate = `Event Date - ${new Date(
      eventDetails.startDate
    ).toLocaleDateString("en-GB")}${
      eventDetails.startDate !== eventDetails.endDate
        ? ` to ${new Date(eventDetails.endDate).toLocaleDateString("en-GB")}`
        : ""
    }`;
    const defaultParticipants = `Total Attendees Participants: ${eventDetails.participantCount}`;
    const defaultRooms = `${
      eventDetails.roomsBooked || 0
    } Rooms Booked for Guests`;
    const finalEditableDate = editableEventDate.trim() || defaultDate;
    const finalParticipants =
      editableParticipantCount.trim() || defaultParticipants;
    const finalRooms = editableRoomsBooked.trim() || defaultRooms;
    console.log("justbefore", image1Base64);
    const payload = {
      EventId: eventDetails.eventId,
      EventName: finalEventName,
      StartDate: finalStartDate,
      EndDate:
        eventDetails.startDate !== eventDetails.endDate
          ? new Date(eventDetails.endDate).toISOString()
          : new Date(eventDetails.startDate).toISOString(),
      EventLocation: finalLocation,

      IntroPara1: finalIntro1,
      // IntroPara2: finalIntro2,
      SustainabilityPara: finalAbout,
      MethodologyPara1: finalMethod1,
      MethodologyPara2: finalMethod2,
      ConclusionText: finalConclusion,

      EditableEventDate: finalEditableDate,
      EditableParticipantCount: finalParticipants,
      EditableRoomsBooked: finalRooms,

      Highlight1: highlight1,
      Highlight2: highlight2,
      Highlight3: highlight3,
      Highlight4: highlight4,

      TextContent1: textContent1,
      TextContent2: textContent2,
      TextContent3: textContent3,
      TextContent4: textContent4,
      TextContent5: textContent5,
      TextContent6: textContent6,
      Image1Base64: image1Base64,
      Image2Base64: image2Base64,
      Image3Base64: image3Base64,
      Image4Base64: image4Base64,
      Image5Base64: image5Base64,
      Image6Base64: image6Base64,
      Image7Base64: image7Base64,
      UploadedLogo64: uploadedLogo64,
    };
    console.log("Payload", payload);

    fetch("https://eventtool-api.octodosolutions.com/api/Reports/SaveReport", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Save failed");
        return res.json();
      })
      .then((_) => {
        setAlertType("success");
        setAlertMessage("Report saved successfully!");
        setShowAlert(true);
      })
      .catch((err) => {
        console.error(err);
        setAlertType("danger");
        setAlertMessage("Error saving report.");
        setShowAlert(true);
      });
  }, [
    eventDetails,
    eventName,
    startDate,
    endDate,
    eventLocation,
    introPara1,
    // introPara2,
    sustainabilityPara,
    methodologyPara1,
    methodologyPara2,
    conclusionText,
    editableEventDate,
    editableParticipantCount,
    editableRoomsBooked,
    highlight1,
    highlight2,
    highlight3,
    highlight4,
    textContent1,
    textContent2,
    textContent3,
    textContent4,
    textContent5,
    textContent6,
    totalEstimatedCarbonEmission,
    image1Base64,
    image2Base64,
    image3Base64,
    image4Base64,
    image5Base64,
    image6Base64,
    image7Base64,
    uploadedLogo64,
  ]);
  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
        handleSave();
        setShowSaveModal(true);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [handleSave]);

  const filteredData = preEventData.filter(
    (item) =>
      item.emissionType === "Invitation Emails" ||
      item.emissionType === "Printed Invitations" ||
      item.emissionType === "Meeting" ||
      item.emissionType === "Marketing Material"
  );
  // Extract the quantity for "Fuel Consumption (Diesel)"
  const fuelConsumption = energyConsumptionData.find(
    (item) => item.emissionSubcategory === "Fuel Consumption (Diesel)"
  );
  const fuelConsumptionQuantity = fuelConsumption
    ? fuelConsumption?.value?.toFixed(2)
    : "0.00";
  // Fetching Natural Gas
  const naturalGasConsumption = energyConsumptionData.find(
    (item) => item.emissionSubcategory === "Natural Gas"
  );
  const naturalGasQuantity = naturalGasConsumption
    ? naturalGasConsumption?.value?.toFixed(2)
    : "0.00";

  // Fetching LPG
  const lpgConsumption = energyConsumptionData.find(
    (item) => item.emissionSubcategory === "LPG"
  );
  const lpgQuantity = lpgConsumption
    ? lpgConsumption?.value?.toFixed(2)
    : "0.00";
  const electricityConsumption = energyConsumptionData.find(
    (item) => item.emissionSubcategory === "Electricity Consumption"
  );
  const electricityConsumptionQuantity = electricityConsumption
    ? electricityConsumption?.value?.toFixed(2)
    : "0.00";
  // Extract values from duringEventData
  // const snacksDrinks = duringEventData.find(
  //   (item) => item.emissionType === "Meals"
  // );
  // const snacksDrinksQuantity = snacksDrinks
  //   ? snacksDrinks.cumulativevalue.toFixed(2)
  //   : "0.00";

  const materialConsumption = duringEventData.find(
    (item) => item.emissionType === "Material Consumption"
  );
  const materialConsumptionQuantity = materialConsumption
    ? materialConsumption.cumulativevalue.toFixed(2)
    : "0.00";
  console.log(" druing event data : ", duringEventData);
  const getEmissionValue = (emissionType) => {
    //console.log("Available Subcategories:", detailedData.map(item => item.emissionSubcategory)); // Log to check

    const dataItem = duringEventData?.find(
      (item) => item.emissionType === emissionType
    );

    return dataItem ? dataItem.cumulativevalue.toFixed(2) : "0.00";
  };
  // Helper function to safely parse cumulative values
  const parseCumulativeValue = (value) => parseFloat(value) || 0.0;

  // Calculate total emission by summing all cumulative values
  const emissionsData = {
    scope1: {
      invitationEmails:
        filteredData
          .find((item) => item.emissionType === "Invitation Emails")
          ?.cumulativevalue.toFixed(2) || "0.00",
      printedInvitations:
        filteredData
          .find((item) => item.emissionType === "Printed Invitations")
          ?.cumulativevalue.toFixed(2) || "0.00",
      gasConsumption: naturalGasQuantity,
      lpgConsumption: lpgQuantity,
      fuelConsumption: fuelConsumptionQuantity || "0.00",
    },
    scope2: {
      electricityConsumption: electricityConsumptionQuantity || "0.00",
    },
    scope3: {
      // snacksDrinks: snacksDrinksQuantity || "0.00",
      marketingMaterial:
        filteredData
          .find((item) => item.emissionType === "Marketing Material")
          ?.cumulativevalue.toFixed(2) || "0.00",
      materialConsumption: materialConsumptionQuantity || "0.00",
      attendeeTravel: getEmissionValue("Attendee Travel"),
      attendeeAccommodation: getEmissionValue("Attendee Accommodation"),
      attendeeMeals: getEmissionValue("Meals"),
      wasteGeneration: wasteGeneration || "0.00",
      shuttleLocalTransport: getEmissionValue("Shuttle Service"),
      preEventMeetings:
        filteredData
          .find((item) => item.emissionType === "Meeting")
          ?.cumulativevalue.toFixed(2) || "0.00",
    },
  };

  // Calculate total emission based on all cumulative values
  const totalEmission =
    parseCumulativeValue(emissionsData.scope1.invitationEmails) +
    parseCumulativeValue(emissionsData.scope1.printedInvitations) +
    parseCumulativeValue(emissionsData.scope1.fuelConsumption) +
    parseCumulativeValue(emissionsData.scope1.gasConsumption) +
    parseCumulativeValue(emissionsData.scope1.lpgConsumption) +
    parseCumulativeValue(emissionsData.scope2.electricityConsumption) +
    parseCumulativeValue(emissionsData.scope3.marketingMaterial) +
    parseCumulativeValue(emissionsData.scope3.shuttleLocalTransport) +
    parseCumulativeValue(emissionsData.scope3.materialConsumption) +
    parseCumulativeValue(emissionsData.scope3.attendeeTravel) +
    parseCumulativeValue(emissionsData.scope3.attendeeAccommodation) +
    parseCumulativeValue(emissionsData.scope3.attendeeMeals) +
    parseCumulativeValue(emissionsData.scope3.wasteGeneration) +
    parseCumulativeValue(emissionsData.scope3.preEventMeetings);

  // Add totalEmission to emissionsData for display
  emissionsData.totalEmission = totalEmission.toFixed(2);

  // Log the final emissionsData object
  console.log("Final Emissions Data with Total Emission:", emissionsData);

  const formatLocation = (location) => {
    if (!location) return "N/A";

    // Split the location by comma and trim each part
    const parts = location.split(",").map((part) => part.trim());

    // Filter out empty or undefined parts
    const validParts = parts.filter((part) => part);

    // Take the last three parts (assuming these represent city, state, and country)
    const lastThreeParts = validParts.slice(-3);

    // Destructure the array to get city, state, and country
    const [city, state, country] = lastThreeParts;

    // Return formatted location with only non-empty values
    return [city, state, country].filter((part) => part).join(", ");
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formattedStartDate = formatDate(eventDetails?.startDate);
  const formattedEndDate = formatDate(eventDetails?.endDate);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };
  console.log("event details boundary : ", eventDetails?.boundary);
  // if (isLoading) {
  //   return <div>Loading event details...</div>;
  // }

  if (!eventDetails || !eventDetails.eventId) {
    return <div>Please wait while we process your report</div>;
  }
  const scope1 =
    (parseFloat(fuelConsumptionQuantity) || 0) +
    (parseFloat(naturalGasQuantity) || 0) +
    (parseFloat(lpgQuantity) || 0);

  // Scope 2 total
  const scope2 = parseFloat(electricityConsumptionQuantity) || 0;

  // Scope 3 total
  const scope3 =
    (filteredData.find((d) => d.emissionType === "Marketing Material")
      ?.cumulativevalue || 0) +
    (filteredData.find((d) => d.emissionType === "Printed Invitations")
      ?.cumulativevalue || 0) +
    (filteredData.find((d) => d.emissionType === "Invitation Emails")
      ?.cumulativevalue || 0) +
    (parseFloat(materialConsumptionQuantity) || 0) +
    (parseFloat(getEmissionValue("Attendee Travel")) || 0) +
    (parseFloat(getEmissionValue("Attendee Accommodation")) || 0) +
    (parseFloat(getEmissionValue("Meals")) || 0) +
    (parseFloat(wasteGeneration) || 0) +
    (parseFloat(getEmissionValue("Shuttle Service")) || 0) +
    (filteredData.find((d) => d.emissionType === "Meeting")?.cumulativevalue ||
      0);

  const emissionsDataByScope = {
    "Scope 1 (Direct Emissions)": parseFloat(scope1.toFixed(2)),
    "Scope 2 (Indirect Emissions)": parseFloat(scope2.toFixed(2)),
    "Scope 3 (Indirect Emissions)": parseFloat(scope3.toFixed(2)),
  };
  console.log("startdate", startDate);

  //console.log("pre event data : ",preEventData);
  return (
    <div className="report-container">
      <EcoIndex />
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center mb-3">
              <div class="main-content-header">Report</div>
            </div>
            <div className="col-md-6 d-flex align-items-center justify-content-end mb-3">
              <h1>{eventDetails?.eventName}</h1>
            </div>
          </div>
          <hr />

          <div className="row p-3">
            <div className="col-md-12 p-0 shadow-box">
              <div className="row">
                <div className="col-md-12">
                  <EventDetailsSidebar eventDetails={eventDetails} />
                </div>
              </div>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 p-0">
                    <div className="White_Box">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="report-buttons d-flex flex-row mt-4">
                            {/* <button className="btn GreenBtn" onClick={handleGenerateReport}>Generate Report</button> */}
                            <PreviewReport
                              eventDetails={eventDetails}
                              sproutImg={sproutImg}
                              uploadedLogo={uploadedLogo}
                              preEventData={preEventData}
                              duringEventData={duringEventData}
                              postEventData={postEventData}
                              totalEstimatedCarbonEmission={
                                totalEstimatedCarbonEmission
                              }
                              attendeeTravelConsumptions={
                                attendeeDetails.attendeeTravelConsumptions
                              }
                              attendeeMealConsumptions={
                                attendeeDetails.attendeeMealConsumptions
                              }
                              attendeeDetails={attendeeDetails}
                              emissionsData={emissionsData}
                              image1={image1}
                              image2={image2}
                              image3={image3}
                              image4={image4}
                              image5={image5}
                              image6={image6}
                              image7={image7}
                              highlight1={highlight1}
                              highlight2={highlight2}
                              highlight3={highlight3}
                              highlight4={highlight4}
                              textContent1={textContent1}
                              textContent2={textContent2}
                              textContent3={textContent3}
                              textContent4={textContent4}
                              textContent5={textContent5}
                              textContent6={textContent6}
                            />
                            {/*<button
                              className="btn GreenButton ml-3"
                              onClick={handleDownloadPDF}
                            >
                              Download PDF
                            </button> */}
                            <button
                              className="btn GreenButton ml-3"
                              onClick={handleDownloadWord}
                            >
                              Download Word
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <EventName />
                        </div>
                      </div>
                      <div
                        style={{
                          padding: "8px 16px",
                          fontSize: "1.5rem",
                          textAlign: "right",
                        }}
                      >
                        Press <kbd>Ctrl</kbd>+<kbd>S</kbd> to save your changes
                      </div>
                      <div className="row" ref={reportRef1}>
                        <div className="col-md-12 p-0">
                          <div className="left_container">
                            <div
                              className="carbon-footprint-image"
                              alt="Carbon Footprint Report"
                            >
                              <div className="left_container_Txt">
                                <div className="left_container_heading">
                                  <h1>CARBON</h1>
                                  <h1>FOOTPRINT</h1>
                                  <h1>REPORT</h1>
                                </div>

                                {/* Container for upload box and i-icon */}
                                <div className="col-md-12 d-flex align-items-center justify-content-center ml-2">
                                  {/* Image upload box */}
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "170px",
                                      height: "170px",
                                    }}
                                  >
                                    {/* Display the uploaded image or upload label */}
                                    {uploadedLogo ? (
                                      <img
                                        src={uploadedLogo}
                                        alt="Uploaded Logo"
                                        style={{
                                          width: "170px",
                                          height: "170px",
                                          objectFit: "contain",
                                        }}
                                      />
                                    ) : (
                                      <label
                                        htmlFor="logoUpload"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "20px",
                                          justifyContent: "center",
                                          alignItem: "center",
                                          width: "100%",
                                          height: "100%",
                                          lineHeight: "10px",
                                          backgroundColor: "#f9f9f9cc",
                                          textAlign: "center",
                                          border: "1px solid #ccc",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Upload Photo
                                      </label>
                                    )}

                                    <input
                                      type="file"
                                      id="logoUpload"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        opacity: 0,
                                        cursor: "pointer",
                                      }}
                                      onChange={handleLogoUpload}
                                      accept="image/*"
                                    />
                                  </div>
                                  {showCropModal && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        {/* cropper wrapper gets flex:1 */}
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={logoFile}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop}
                                            onZoomChange={setZoom}
                                            onCropComplete={onCropComplete}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom}
                                            onChange={(e) =>
                                              setZoom(e.target.value)
                                            }
                                          />
                                          <button
                                            className="logoCropper__btn"
                                            onClick={() =>
                                              setShowCropModal(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            className="logoCropper__btn logoCropper__btn--primary"
                                            onClick={applyCrop}
                                          >
                                            Save Logo
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="report-event-details">
                                  <h2
                                    key={eventName}
                                    contentEditable
                                    suppressContentEditableWarning
                                    className="editableParagraph"
                                    onBlur={(e) =>
                                      setEventName(e.currentTarget.textContent)
                                    }
                                  >
                                    {eventName || eventDetails.eventName}
                                  </h2>

                                  <h6>from</h6>
                                  <h3
                                    KEY={startDate}
                                    contentEditable
                                    suppressContentEditableWarning={true}
                                    className="editableParagraph"
                                    onBlur={(e) =>
                                      setStartDate(e.target.innerText)
                                    }
                                  >
                                    {startDate ||
                                      new Date(
                                        eventDetails.startDate
                                      ).toLocaleDateString("en-GB")}
                                  </h3>

                                  {eventDetails.startDate !==
                                    eventDetails.endDate && (
                                    <>
                                      <h6>to</h6>
                                      <h3
                                        contentEditable
                                        suppressContentEditableWarning={true}
                                        className="editableParagraph"
                                        onBlur={(e) =>
                                          setEndDate(e.target.innerText)
                                        }
                                      >
                                        {endDate ||
                                          new Date(
                                            eventDetails.endDate
                                          ).toLocaleDateString("en-GB")}
                                      </h3>
                                    </>
                                  )}

                                  <hr />

                                  <p
                                    contentEditable
                                    suppressContentEditableWarning={true}
                                    className="editableParagraph"
                                    onBlur={(e) =>
                                      setEventLocation(e.target.innerText)
                                    }
                                  >
                                    {eventLocation ||
                                      `${
                                        formatLocation(
                                          eventDetails.location
                                        ).split(",")[0]
                                      } - ${
                                        formatLocation(
                                          eventDetails.location
                                        ).split(",")[1]
                                      }
                                    \n${
                                      formatLocation(
                                        eventDetails.location
                                      ).split(",")[2]
                                    }`}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row-report page-break" ref={reportRef2}>
                        <div className="col-md-12">
                          <div className="PageTitleLogo">
                            <div className="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div className="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Cool Logo"
                              />
                            </div>
                            <div className="clearfix"></div>
                          </div>
                          <div
                            className={`ImgWrp1 ${
                              image1 ? "no-background" : ""
                            }`}
                          >
                            {image1 ? (
                              <img src={image1} alt="Preview 1" />
                            ) : (
                              <label
                                htmlFor="imageUpload1"
                                style={{
                                  display: "inline-block",
                                  width: "1000px",
                                  height: "800px",
                                  backgroundColor: "#f9f9f9cc",
                                  textAlign: "center",
                                  lineHeight: "50px",
                                  border: "none",
                                  cursor: "pointer",
                                  marginLeft: "-50px",
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    transform: "translateY(-50%)",
                                    marginTop: "400px",
                                  }}
                                >
                                  Upload photo for carbon emission report
                                </span>
                              </label>
                            )}

                            {/* Invisible file input overlay */}
                            <input
                              type="file"
                              id="imageUpload1"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "500px",
                                height: "400px",
                                opacity: 0,
                                cursor: "pointer",
                              }}
                              onChange={handleImageUpload1} // Handle file change
                              accept="image/*"
                            />

                            {showCropModal1 && (
                              <div className="logoCropper__overlay">
                                <div className="logoCropper__dialog">
                                  <div className="logoCropper__crop-area">
                                    <Cropper
                                      image={image1File}
                                      crop={crop1}
                                      zoom={zoom1}
                                      aspect={1}
                                      cropShape="rect"
                                      showGrid={false}
                                      onCropChange={setCrop1}
                                      onZoomChange={setZoom1}
                                      onCropComplete={onCropComplete1}
                                    />
                                  </div>
                                  <div className="logoCropper__controls">
                                    <input
                                      type="range"
                                      min={1}
                                      max={3}
                                      step={0.1}
                                      value={zoom1}
                                      onChange={(e) => setZoom1(e.target.value)}
                                    />
                                    <button
                                      onClick={() => setShowCropModal1(false)}
                                    >
                                      Cancel
                                    </button>
                                    <button onClick={applyCrop1}>Save</button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="report-event-title-page">
                            <h1 className="report-event-name">
                              {eventName || eventDetails.eventName}
                            </h1>
                            <p className="report-organizer-label">
                              Organized by
                            </p>
                            {uploadedLogo && (
                              <img
                                src={uploadedLogo}
                                alt="Organizer Logo"
                                className="report-organizer-logo"
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row-report page-break" ref={reportRef3}>
                        <div className="col-md-12">
                          <div className="PageTitleLogo">
                            <div className="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div className="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Cool Logo"
                              />
                            </div>
                            <div className="clearfix"></div>
                          </div>
                          <div className="GreenBoxTitle">
                            {" "}
                            PURPOSE OF THE ASSESSMENT{" "}
                          </div>
                          <div className="mainTxt">
                            <div
                              contentEditable
                              suppressContentEditableWarning={true}
                              className="editableParagraph"
                              onBlur={(e) => setIntroPara1(e.target.innerText)}
                            >
                              {introPara1 ||
                                `The purpose of this assessment is to calculate the environmental impact of ${
                                  eventDetails.eventName
                                }, held on ${formatDate(
                                  eventDetails.startDate
                                )}${
                                  eventDetails.startDate !==
                                  eventDetails.endDate
                                    ? ` to ${formatDate(eventDetails.endDate)}`
                                    : ""
                                } at ${formatLocation(
                                  eventDetails.location
                                )} by evaluating its carbon footprint. Through this process, we aim to promote sustainability by identifying opportunities to reduce greenhouse gas emissions and enhance environmental stewardship within event management practices. The purpose of this report is to calculate the carbon footprint and establish a baseline that can serve as a reference for future events to reduce their carbon footprint.`}
                            </div>
                          </div>

                          <br />
                          <br />
                          <div className="GreenBoxTitle"> ABOUT THE EVENT </div>
                          <div className="mainTxt">
                            <div
                              contentEditable
                              suppressContentEditableWarning={true}
                              className="editableParagraph"
                              onBlur={(e) =>
                                setSustainabilityPara(e.target.innerText)
                              }
                            >
                              {sustainabilityPara ||
                                `${
                                  eventDetails.eventName || "Event Name"
                                } was designed with sustainability as a core focus, aiming to minimize its environmental impact while maximizing the positive outcomes for attendees. Through careful planning, we incorporated eco-friendly practices at every stage, from transportation and venue selection to catering and waste management. The organizing team was committed to reduce the event's carbon footprint and calculate the total impact of event on environment, and we are proud to present the calculated carbon emissions as part of our effort to promote transparency and continual improvement in sustainability practices.`}
                            </div>
                          </div>

                          <br />
                          <br />
                          <div className="GreenBoxTitle">
                            {" "}
                            EVENT HIGHLIGHTS
                            <span className="tooltip-icon no-pdf">
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                              />
                              <span className="tooltip-text">
                                You can take the example of below given
                                Highlights and write your own :
                                <br /> 1. 15 Category of Awards
                                <br /> 2. Cultural & Musical Events
                                <br /> 3. Decarbonization Theme
                                <br /> 4. 398 Room Booked for Guests
                              </span>
                            </span>
                          </div>

                          <div className="GreenBox">
                            <ul>
                              <li>
                                <div
                                  contentEditable
                                  suppressContentEditableWarning={true}
                                  className="editableParagraphhighlight"
                                  onBlur={(e) =>
                                    setEditableEventDate(e.target.innerText)
                                  }
                                >
                                  {editableEventDate ||
                                    `Event Date - ${new Date(
                                      eventDetails.startDate
                                    ).toLocaleDateString("en-GB")}${
                                      eventDetails.startDate !==
                                      eventDetails.endDate
                                        ? ` to ${new Date(
                                            eventDetails.endDate
                                          ).toLocaleDateString("en-GB")}`
                                        : ""
                                    }`}
                                </div>
                              </li>

                              <li>
                                <div
                                  contentEditable
                                  suppressContentEditableWarning={true}
                                  className="editableParagraphhighlight"
                                  onBlur={(e) =>
                                    setEditableParticipantCount(
                                      e.target.innerText
                                    )
                                  }
                                >
                                  {editableParticipantCount ||
                                    `Total Attendees Participants: ${eventDetails.participantCount}`}
                                </div>
                              </li>

                              <li>
                                <div
                                  contentEditable
                                  suppressContentEditableWarning={true}
                                  className="editableParagraphhighlight"
                                  onBlur={(e) =>
                                    setEditableRoomsBooked(e.target.innerText)
                                  }
                                >
                                  {editableRoomsBooked ||
                                    `${
                                      eventDetails.roomsBooked || "0"
                                    } Rooms Booked for Guests`}
                                </div>
                              </li>

                              <li>
                                <input
                                  type="text"
                                  className={`inputField editableField ${
                                    highlight1 ? "no-border" : ""
                                  }`}
                                  placeholder="---Add Highlight---"
                                  value={highlight1}
                                  onChange={(e) =>
                                    setHighlight1(e.target.value)
                                  }
                                />
                              </li>
                              <li>
                                <input
                                  type="text"
                                  className={`inputField editableField ${
                                    highlight2 ? "no-border" : ""
                                  }`}
                                  placeholder="---Add Highlight---"
                                  value={highlight2}
                                  onChange={(e) =>
                                    setHighlight2(e.target.value)
                                  }
                                />
                              </li>
                              <li>
                                <input
                                  type="text"
                                  className={`inputField editableField ${
                                    highlight3 ? "no-border" : ""
                                  }`}
                                  placeholder="---Add Highlight---"
                                  value={highlight3}
                                  onChange={(e) =>
                                    setHighlight3(e.target.value)
                                  }
                                />
                              </li>
                              <li>
                                <input
                                  type="text"
                                  className={`inputField editableField ${
                                    highlight4 ? "no-border" : ""
                                  }`}
                                  placeholder="---Add Highlight---"
                                  value={highlight4}
                                  onChange={(e) =>
                                    setHighlight4(e.target.value)
                                  }
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row-report page-break" ref={reportRef4}>
                        <div className="col-md-12">
                          <div className="PageTitleLogo">
                            <div className="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div className="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Cool Logo"
                              />
                            </div>
                            <div className="clearfix"></div>
                          </div>
                          <div class="GreenBoxTitle">
                            {" "}
                            IMAGES OF EMISSION REDUCTION STRATEGIES
                          </div>
                          <br />
                          <br />
                          <div class="mainTxt">
                            <div class="row">
                              <div class="col-md-6">
                                <div
                                  className={`ImgWrp ${
                                    image2 ? "no-background" : ""
                                  }`}
                                >
                                  {image2 ? (
                                    <img src={image2} alt="Preview 2" />
                                  ) : (
                                    <label htmlFor="imageUpload2">
                                      <span
                                        style={{
                                          display: "inline-block",
                                          transform: "translateY(-50%)",
                                          marginTop: "10px",
                                        }}
                                      >
                                        Upload Picture for Sustainability
                                        Measure 1
                                      </span>
                                    </label>
                                  )}

                                  {/* Invisible file input overlay */}
                                  <input
                                    type="file"
                                    id="imageUpload2"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    onChange={handleImageUpload2}
                                    accept="image/*"
                                  />
                                  {showCropModal2 && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={image2File}
                                            crop={crop2}
                                            zoom={zoom2}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop2}
                                            onZoomChange={setZoom2}
                                            onCropComplete={onCropComplete2}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom2}
                                            onChange={(e) =>
                                              setZoom2(e.target.value)
                                            }
                                          />
                                          <button
                                            onClick={() =>
                                              setShowCropModal2(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button onClick={applyCrop2}>
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* Text input */}
                                  <div className="textWrp">
                                    <input
                                      type="text"
                                      placeholder="---Add Title---"
                                      value={textContent1}
                                      onChange={(e) =>
                                        setTextContent1(e.target.value)
                                      }
                                      className="editableText"
                                      style={{
                                        width: "100%",
                                        padding: "5px",
                                        border: "1px solid #ccc",
                                        color: "white", // Set text color to white
                                        backgroundColor: "transparent",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div
                                  className={`ImgWrp ${
                                    image3 ? "no-background" : ""
                                  }`}
                                >
                                  {image3 ? (
                                    <img src={image3} alt="Preview 2" />
                                  ) : (
                                    <label htmlFor="imageUpload3">
                                      <span
                                        style={{
                                          display: "inline-block",
                                          transform: "translateY(-50%)",
                                          marginTop: "10px",
                                        }}
                                      >
                                        Upload Picture for Sustainability
                                        Measure 2
                                      </span>
                                    </label>
                                  )}

                                  {/* Invisible file input overlay */}
                                  <input
                                    type="file"
                                    id="imageUpload3"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    onChange={handleImageUpload3}
                                    accept="image/*"
                                  />
                                  {showCropModal3 && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={image3File}
                                            crop={crop3}
                                            zoom={zoom3}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop3}
                                            onZoomChange={setZoom3}
                                            onCropComplete={onCropComplete3}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom3}
                                            onChange={(e) =>
                                              setZoom3(e.target.value)
                                            }
                                          />
                                          <button
                                            onClick={() =>
                                              setShowCropModal3(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button onClick={applyCrop3}>
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Text input */}
                                  <div className="textWrp">
                                    <input
                                      type="text"
                                      placeholder="---Add Title---"
                                      value={textContent2}
                                      onChange={(e) =>
                                        setTextContent2(e.target.value)
                                      }
                                      className="editableText"
                                      style={{
                                        width: "100%",
                                        padding: "5px",
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix"></div>

                              <div class="col-md-6">
                                <div
                                  className={`ImgWrp ${
                                    image4 ? "no-background" : ""
                                  }`}
                                >
                                  {image4 ? (
                                    <img src={image4} alt="Preview 4" />
                                  ) : (
                                    <label htmlFor="imageUpload4">
                                      <span
                                        style={{
                                          display: "inline-block",
                                          transform: "translateY(-50%)",
                                          marginTop: "22px",
                                        }}
                                      >
                                        Upload Picture for Sustainability
                                        Measure 3
                                      </span>
                                    </label>
                                  )}

                                  {/* Invisible file input overlay */}
                                  <input
                                    type="file"
                                    id="imageUpload4"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    onChange={handleImageUpload4} // Handle file change
                                    accept="image/*"
                                  />
                                  {showCropModal4 && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={image4File}
                                            crop={crop4}
                                            zoom={zoom4}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop4}
                                            onZoomChange={setZoom4}
                                            onCropComplete={onCropComplete4}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom4}
                                            onChange={(e) =>
                                              setZoom4(e.target.value)
                                            }
                                          />
                                          <button
                                            onClick={() =>
                                              setShowCropModal4(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button onClick={applyCrop4}>
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Text input */}
                                  <div className="textWrp">
                                    <input
                                      type="text"
                                      placeholder="---Add Title---"
                                      value={textContent3}
                                      onChange={(e) =>
                                        setTextContent3(e.target.value)
                                      }
                                      className="editableText"
                                      style={{
                                        width: "100%",
                                        padding: "5px",
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div
                                  className={`ImgWrp ${
                                    image5 ? "no-background" : ""
                                  }`}
                                >
                                  {image5 ? (
                                    <img src={image5} alt="Preview 5" />
                                  ) : (
                                    <label htmlFor="imageUpload5">
                                      <span>
                                        Upload Picture for Sustainability
                                        Measure 4
                                      </span>
                                    </label>
                                  )}

                                  {/* Invisible file input overlay */}
                                  <input
                                    type="file"
                                    id="imageUpload5"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    onChange={handleImageUpload5} // Handle file change
                                    accept="image/*"
                                  />
                                  {showCropModal5 && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={image5File}
                                            crop={crop5}
                                            zoom={zoom5}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop5}
                                            onZoomChange={setZoom5}
                                            onCropComplete={onCropComplete5}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom5}
                                            onChange={(e) =>
                                              setZoom5(e.target.value)
                                            }
                                          />
                                          <button
                                            onClick={() =>
                                              setShowCropModal5(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button onClick={applyCrop5}>
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Text input */}
                                  <div className="textWrp">
                                    <input
                                      type="text"
                                      placeholder="---Add Title---"
                                      value={textContent4}
                                      onChange={(e) =>
                                        setTextContent4(e.target.value)
                                      }
                                      className="editableText"
                                      style={{
                                        width: "100%",
                                        padding: "5px",
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix"></div>

                              <div class="col-md-6">
                                <div
                                  className={`ImgWrp ${
                                    image6 ? "no-background" : ""
                                  }`}
                                >
                                  {image6 ? (
                                    <img src={image6} alt="Preview 6" />
                                  ) : (
                                    <label htmlFor="imageUpload6">
                                      <span>
                                        Upload Picture for Sustainability
                                        Measure 5
                                      </span>
                                    </label>
                                  )}

                                  {/* Invisible file input overlay */}
                                  <input
                                    type="file"
                                    id="imageUpload6"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    onChange={handleImageUpload6} // Handle file change
                                    accept="image/*"
                                  />
                                  {showCropModal6 && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={image6File}
                                            crop={crop6}
                                            zoom={zoom6}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop6}
                                            onZoomChange={setZoom6}
                                            onCropComplete={onCropComplete6}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom6}
                                            onChange={(e) =>
                                              setZoom6(e.target.value)
                                            }
                                          />
                                          <button
                                            onClick={() =>
                                              setShowCropModal6(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button onClick={applyCrop6}>
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Text input */}
                                  <div
                                    className="textWrp"
                                    style={{ marginTop: "10px" }}
                                  >
                                    <input
                                      type="text"
                                      placeholder="---Add Title---"
                                      value={textContent5}
                                      onChange={(e) =>
                                        setTextContent5(e.target.value)
                                      }
                                      className="editableText"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div
                                  className={`ImgWrp ${
                                    image7 ? "no-background" : ""
                                  }`}
                                >
                                  {image7 ? (
                                    <img src={image7} alt="Preview 7" />
                                  ) : (
                                    <label htmlFor="imageUpload7">
                                      <span>
                                        Upload Picture for Sustainability
                                        Measure 6
                                      </span>
                                    </label>
                                  )}

                                  {/* Invisible file input overlay */}
                                  <input
                                    type="file"
                                    id="imageUpload7"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    onChange={handleImageUpload7} // Handle file change
                                    accept="image/*"
                                  />
                                  {showCropModal7 && (
                                    <div className="logoCropper__overlay">
                                      <div className="logoCropper__dialog">
                                        <div className="logoCropper__crop-area">
                                          <Cropper
                                            image={image7File}
                                            crop={crop7}
                                            zoom={zoom7}
                                            aspect={1}
                                            cropShape="rect"
                                            showGrid={false}
                                            onCropChange={setCrop7}
                                            onZoomChange={setZoom7}
                                            onCropComplete={onCropComplete7}
                                          />
                                        </div>
                                        <div className="logoCropper__controls">
                                          <input
                                            type="range"
                                            min={1}
                                            max={3}
                                            step={0.1}
                                            value={zoom7}
                                            onChange={(e) =>
                                              setZoom7(e.target.value)
                                            }
                                          />
                                          <button
                                            onClick={() =>
                                              setShowCropModal7(false)
                                            }
                                          >
                                            Cancel
                                          </button>
                                          <button onClick={applyCrop7}>
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Text input */}
                                  <div className="textWrp">
                                    <input
                                      type="text"
                                      placeholder="---Add Title---"
                                      value={textContent6}
                                      onChange={(e) =>
                                        setTextContent6(e.target.value)
                                      }
                                      className="editableText"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row-report page-break" ref={reportRef5}>
                        <div class="col-md-12">
                          <div class="PageTitleLogo">
                            <div class="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Sprout"
                              />
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div class="GreenBoxTitle"> METHODOLOGY </div>
                          <div class="mainTxt">
                            <p>
                              Calculating the carbon footprint of an event
                              involves assessing all activities related to the
                              event that contribute to greenhouse gas emissions.
                              This includes direct emissions from energy
                              consumption at the venue, indirect emissions from
                              attendee and staff travel, accommodation, and
                              waste management, as well as emissions from the
                              production and disposal of materials used. Data on
                              energy usage, transportation distances, waste
                              generated, and other relevant factors are
                              collected and multiplied by appropriate emission
                              factors to convert them into carbon dioxide
                              equivalents (CO2e). The total emissions from all
                              sources are then aggregated to determine the
                              event's overall carbon footprint. This information
                              can be used to identify the largest sources of
                              emissions, report on the environmental impact, and
                              explore options for offsetting or reducing the
                              event's carbon footprint.
                            </p>
                            <p>
                              For better understanding all activities has been
                              divided in the Pre-Event, During Event and Post
                              Event section so that monitoring of data and
                              calculation became easy. This methodology enhanced
                              the boundary of event as it includes emissions
                              associated with pre-event planning also.{" "}
                            </p>
                          </div>

                          <br />
                          <br />
                          <br />
                          <div class="GreenBoxTitle">
                            {" "}
                            CARBON EMISSION HEADS{" "}
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="PreEvent">
                                <div class="title">Pre Event</div>
                                <div>
                                  <ul>
                                    <li>Marketing & Invitation Mails </li>
                                    <li>Printed Invitation </li>
                                    <li>Printed Marketing Materials </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">
                              {" "}
                              <div class="DuringEvent">
                                <div class="title">During Event</div>
                                <div>
                                  <ul>
                                    <li>
                                      Attendee Travel, Accommodation &amp; Meals
                                    </li>
                                    <li>Energy Consumption</li>
                                    {/* {                                    <li>Snacks &amp; Drinks</li> */}
                                    <li>Material Consumption</li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <div class="PostEvent">
                                <div class="title">Post Event</div>
                                <div>
                                  <ul>
                                    <li>Waste Generated</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row-report page-break" ref={reportRef6}>
                        <div class="col-md-12">
                          <div class="PageTitleLogo">
                            <div class="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Sprout"
                              />
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div class="mainTxt">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th valign="top">
                                    <strong>Activities</strong>
                                  </th>
                                  <th valign="top">
                                    <strong>Emissions (kgCO2e)</strong>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td
                                    colSpan="2"
                                    align="center"
                                    valign="top"
                                    bgcolor="#B9CDE5"
                                  >
                                    <strong>Pre Event</strong>
                                  </td>
                                </tr>
                                {preEventData.map((item, index) => (
                                  <tr key={index}>
                                    <td valign="top">{item.emissionType}</td>
                                    <td valign="top">
                                      {item.cumulativevalue.toFixed(2)}
                                    </td>
                                  </tr>
                                ))}

                                <tr>
                                  <td
                                    colSpan="2"
                                    align="center"
                                    valign="top"
                                    bgcolor="#B9CDE5"
                                  >
                                    <strong>During Event</strong>
                                  </td>
                                </tr>
                                {duringEventData.map((item, index) => (
                                  <tr key={index}>
                                    <td valign="top">{item.emissionType}</td>
                                    <td valign="top">
                                      {item.cumulativevalue.toFixed(2)}
                                    </td>
                                  </tr>
                                ))}

                                <tr>
                                  <td
                                    colSpan="2"
                                    align="center"
                                    valign="top"
                                    bgcolor="#B9CDE5"
                                  >
                                    <strong>Post Event</strong>
                                  </td>
                                </tr>
                                {postEventData.map((item, index) => (
                                  <tr key={index}>
                                    <td valign="top">
                                      {item.emissionType.includes("Quantity of")
                                        ? item.emissionType
                                            .replace("Quantity of", "")
                                            .trim()
                                        : item.emissionType}
                                    </td>
                                    <td valign="top">
                                      {item.cumulativevalue.toFixed(2)}
                                    </td>
                                  </tr>
                                ))}

                                <tr>
                                  <td
                                    rowspan="2"
                                    align="left"
                                    valign="baseline"
                                    bgcolor="#DDD9C3"
                                  >
                                    <strong>
                                      Total Emission from{" "}
                                      {eventDetails.eventName} event
                                    </strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top" bgcolor="#DDD9C3">
                                    {" "}
                                    <strong>
                                      {emissionsData.totalEmission} kgCO₂
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="mainTxt">
                            <p style={{ fontSize: "18px" }}>
                              <strong
                                class="GreenBoxTitlees"
                                style={{ marginLeft: "15px" }}
                              >
                                BOUNDARIES:
                              </strong>
                            </p>

                            <p
                              className="no-font-size-change"
                              style={{ fontSize: "12px" }}
                            >
                              <span
                                className="blueClr"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                Event:
                              </span>
                              <span
                                className="event-duration"
                                style={{
                                  color: "#555",
                                  marginLeft: "5px",
                                  fontSize: "13px",
                                }}
                              >
                                duration (days), attendees (number)
                              </span>
                            </p>
                            <p
                              className="no-font-size-change"
                              style={{ fontSize: "12px" }}
                            >
                              <span
                                className="blueClr"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                Travel:{" "}
                              </span>
                              <span
                                className="travel-details"
                                style={{
                                  color: "#555",
                                  marginLeft: "5px",
                                  fontSize: "13px",
                                }}
                              >
                                guest, participants, and organizers travel by
                                mode (air, private vehicle, public transport)
                                and distance.
                              </span>
                            </p>
                            <p
                              className="no-font-size-change"
                              style={{ fontSize: "14px" }}
                            >
                              <span
                                className="blueClr"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                Accommodation:{" "}
                              </span>
                              <span
                                className="travel-details"
                                style={{
                                  color: "#555",
                                  marginLeft: "5px",
                                  fontSize: "13px",
                                }}
                              >
                                hotel nights for guests, build crew, or stand
                                staffing.
                              </span>
                            </p>
                            <p
                              className="no-font-size-change"
                              style={{ fontSize: "12px" }}
                            >
                              <span
                                className="blueClr"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                Catering:{" "}
                              </span>
                              <span
                                className="travel-details"
                                style={{
                                  color: "#555",
                                  marginLeft: "5px",
                                  fontSize: "13px",
                                }}
                              >
                                includes number of meals (non-vegetarian,
                                vegetarian, vegan) consumed by guests, crew, and
                                build staff for the duration of the event.
                              </span>
                            </p>
                            <p
                              className="no-font-size-change"
                              style={{ fontSize: "12px" }}
                            >
                              <span
                                className="blueClr"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                Energy:
                              </span>
                              <span
                                className="travel-details"
                                style={{
                                  color: "#555",
                                  marginLeft: "5px",
                                  fontSize: "13px",
                                }}
                              >
                                actual consumption as estimated or measured by
                                venue (kWh)
                              </span>
                            </p>
                            {eventDetails.boundary.includes(
                              "Material Consumption"
                            ) && (
                              <p
                                className="no-font-size-change"
                                style={{ fontSize: "12px" }}
                              >
                                <span
                                  className="blueClr"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Materials:{" "}
                                </span>
                                <span
                                  className="travel-details"
                                  style={{
                                    color: "#555",
                                    marginLeft: "5px",
                                    fontSize: "13px",
                                  }}
                                >
                                  printed matter, plastics, recyclable
                                  materials, and other materials used in stand
                                  build &amp; delivery.
                                </span>
                              </p>
                            )}
                            {eventDetails.boundary.includes(
                              "Material Consumption"
                            ) && (
                              <p
                                className="no-font-size-change"
                                style={{ fontSize: "12px" }}
                              >
                                <span
                                  className="blueClr"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Transportation:{" "}
                                </span>
                                <span
                                  className="travel-details"
                                  style={{
                                    color: "#555",
                                    marginLeft: "5px",
                                    fontSize: "13px",
                                  }}
                                >
                                  transported weight of infrastructure, AV,
                                  materials, furniture, and other stand-based
                                  items, distance, and mode of transportation.
                                </span>
                              </p>
                            )}

                            <p
                              className="no-font-size-change"
                              style={{ fontSize: "12px" }}
                            >
                              <span
                                className="blueClr"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                Waste:
                              </span>
                              <span
                                className="travel-details"
                                style={{
                                  color: "#555",
                                  marginLeft: "5px",
                                  fontSize: "13px",
                                }}
                              >
                                recyclable and residual waste
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="row-report page-break" ref={reportRef7}>
                        <div class="col-md-12">
                          <div class="PageTitleLogo">
                            <div class="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Sprout"
                              />
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div class="mainTxt">
                            <div className="chart-table-container">
                              <div
                                className="chart-section"
                                style={{
                                  border: "none !important",
                                  boxShadow: "none !important",
                                }}
                              >
                                <DoughnutChart
                                  eventId={eventDetails?.eventId}
                                  totalEventEmission={
                                    totalEstimatedCarbonEmission
                                  }
                                  ref={preEventChartRef}
                                />
                              </div>

                              <div className="table-section">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Emission Type</th>
                                      <th>Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Object.keys(preEventData).map(
                                      (key, index) => (
                                        <tr key={index}>
                                          <td>
                                            {preEventData[key].emissionType}
                                          </td>
                                          <td>
                                            {preEventData[
                                              key
                                            ].cumulativevalue.toFixed(2)}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row-report page-break">
                          <div class="col-md-12">
                            <div class="PageTitleLogo">
                              {/* <div class="pull-left"><img src={sproutImg} width="103" height="50" alt="Sprout" /></div> */}
                              {/* <div class="pull-right"><img src={uploadedLogo} width="50" height="50" alt="Sprout" /></div> */}
                              <div class="clearfix"></div>
                            </div>
                            <div class="mainTxt">
                              <div className="chart-table-container">
                                <div
                                  className="chart-section"
                                  style={{
                                    border: "none",
                                    boxShadow: "none",
                                  }}
                                >
                                  <DoughnutChart2
                                    eventId={eventDetails.eventId}
                                    totalEventEmission={
                                      totalEstimatedCarbonEmission
                                    }
                                    ref={duringEventChartRef}
                                  />
                                </div>
                                <div className="table-section">
                                  <table
                                    style={{
                                      width: "80%",
                                      tableLayout: "fixed",
                                    }}
                                  >
                                    <thead style={{ width: "70%" }}>
                                      <tr>
                                        <th>Emission Type</th>
                                        <th>Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.keys(duringEventData).map(
                                        (key, index) => (
                                          <tr key={index}>
                                            <td>
                                              {
                                                duringEventData[key]
                                                  .emissionType
                                              }
                                            </td>
                                            <td>
                                              {duringEventData[
                                                key
                                              ].cumulativevalue.toFixed(2)}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row-report page-break">
                          <div class="col-md-12">
                            <div class="PageTitleLogo">
                              {/* <div class="pull-left"><img src={sproutImg} width="103" height="50" alt="Sprout" /></div> */}
                              {/* <div class="pull-right"><img src={uploadedLogo} width="50" height="50" alt="Sprout" /></div> */}
                              <div class="clearfix"></div>
                            </div>
                            <div class="mainTxt">
                              <div className="chart-table-container">
                                <div
                                  className="chart-section"
                                  style={{
                                    border: "none",
                                    boxShadow: "none",
                                  }}
                                >
                                  <DoughnutChart3
                                    eventId={eventDetails.eventId}
                                    totalEventEmission={
                                      totalEstimatedCarbonEmission
                                    }
                                    ref={postEventChartRef}
                                  />
                                </div>
                                <div className="table-section">
                                  <table
                                    style={{
                                      width: "80%",
                                      tableLayout: "fixed",
                                    }}
                                  >
                                    <thead style={{ width: "70%" }}>
                                      <tr>
                                        <th>Emission Type</th>
                                        <th>Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.keys(postEventData).map(
                                        (key, index) => (
                                          <tr key={index}>
                                            <td>
                                              {postEventData[
                                                key
                                              ].emissionType.includes(
                                                "Quantity of"
                                              )
                                                ? postEventData[
                                                    key
                                                  ].emissionType
                                                    .replace("Quantity of", "")
                                                    .trim()
                                                : postEventData[key]
                                                    .emissionType}
                                            </td>
                                            <td>
                                              {postEventData[
                                                key
                                              ].cumulativevalue.toFixed(2)}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row-report page-break" ref={reportRef8}>
                        <div class="col-md-12">
                          <div class="PageTitleLogo">
                            <div class="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="pull-right">
                              <img
                                src={uploadedLogo}
                                width="50"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div class="mainTxt">
                            <TravelModeDoughnutChart
                              attendeeTravelConsumptions={
                                attendeeDetails.attendeeTravelConsumptions
                              }
                              ref={TravelChartRef}
                            />
                            <ScopeEmissionDoughnutChart
                              scopeData={emissionsDataByScope}
                              ref={scopeChartRef}
                              tablePosition="right"
                            />
                          </div>
                        </div>

                        <div class="row-report page-break">
                          <div class="col-md-12">
                            {/* <div class="PageTitleLogo">
                            <div class="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Sprout"
                              />
                            </div>
                            <div class="clearfix"></div>
                          </div> */}
                            {/* <div class="mainTxt">
                           <MealConsumptionDoughnutChart
                              attendeeMealConsumptions={
                                attendeeDetails.attendeeMealConsumptions
                              }
                            />
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div class="row-report page-break" ref={reportRef12}>
                        <div class="col-md-12">
                          <div class="PageTitleLogo">
                            <div class="pull-left">
                              <img
                                src={sproutImg}
                                width="103"
                                height="50"
                                alt="Sprout"
                              />
                            </div>
                            <div class="pull-right">
                              <img
                                src={uploadedLogo}
                                width="70"
                                height="70"
                                alt="Sprout"
                              />
                            </div>
                            <div class="clearfix"></div>
                          </div>
                          <div
                            className="mainTxt"
                            style={{ width: "100% !important" }}
                          >
                            <div className="GreenBoxTitle">
                              Emissions Breakdown by Scope and Activity
                            </div>
                            <br />
                            <table
                              className="table table-bordered"
                              style={{
                                display: "table",
                                width: "100% !important",
                                borderCollapse: "collapse",
                                tableLayout: "fixed",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th>Scope</th>
                                  <th>Activities</th>
                                  <th>Emissions (kgCO2e)</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {/* Scope 1 spans three rows */}
                                  <td
                                    rowSpan="4"
                                    valign="top"
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    Scope 1 (Direct Emissions)
                                  </td>
                                </tr>

                                <tr>
                                  <td valign="top">
                                    Fuel Consumption in DG Sets and
                                    Transportation
                                  </td>
                                  <td valign="top">
                                    {fuelConsumptionQuantity}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Gas Consumption</td>
                                  <td valign="top">{naturalGasQuantity}</td>
                                </tr>
                                <tr>
                                  <td valign="top">LPG Consumption</td>
                                  <td valign="top">{lpgQuantity}</td>
                                </tr>
                                <tr>
                                  {/* Scope 2 starts */}
                                  <td valign="top">
                                    Scope 2 (Indirect Emissions)
                                  </td>
                                  <td valign="top">Electricity Consumption</td>
                                  <td valign="top">
                                    {electricityConsumptionQuantity}
                                  </td>
                                </tr>
                                <tr>
                                  {/* Scope 3 starts */}
                                  <td rowSpan="10" valign="top">
                                    Scope 3 (Indirect Emissions)
                                  </td>
                                  <td valign="top">Marketing Material</td>
                                  <td valign="top">
                                    {filteredData
                                      .find(
                                        (item) =>
                                          item.emissionType ===
                                          "Marketing Material"
                                      )
                                      ?.cumulativevalue.toFixed(2) || "0.00"}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Printed Invitations</td>
                                  <td valign="top">
                                    {filteredData
                                      .find(
                                        (item) =>
                                          item.emissionType ===
                                          "Printed Invitations"
                                      )
                                      ?.cumulativevalue.toFixed(2) || "0.00"}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Invitation Emails</td>
                                  <td valign="top">
                                    {filteredData
                                      .find(
                                        (item) =>
                                          item.emissionType ===
                                          "Invitation Emails"
                                      )
                                      ?.cumulativevalue.toFixed(2) || "0.00"}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Material Consumption</td>
                                  <td valign="top">
                                    {materialConsumptionQuantity}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Attendee Travel</td>
                                  <td valign="top">
                                    {getEmissionValue("Attendee Travel")}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Attendee Accommodation</td>
                                  <td valign="top">
                                    {getEmissionValue("Attendee Accommodation")}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Meals</td>
                                  <td valign="top">
                                    {getEmissionValue("Meals")}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Waste Generation</td>
                                  <td valign="top">{wasteGeneration}</td>
                                </tr>
                                <tr>
                                  <td valign="top">Shuttle/Local Transport</td>
                                  <td valign="top">
                                    {getEmissionValue("Shuttle Service")}
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">Pre Event Meetings</td>
                                  <td valign="top">
                                    {filteredData
                                      .find(
                                        (item) =>
                                          item.emissionType === "Meeting"
                                      )
                                      ?.cumulativevalue.toFixed(2) || "0.00"}
                                  </td>
                                </tr>
                                <tr>
                                  {/* Total emission row */}
                                  <td valign="top" bgcolor="#DDD9C3">
                                    <strong>
                                      Total Emission from{" "}
                                      {eventDetails.eventName} event
                                    </strong>
                                  </td>
                                  <td valign="top" bgcolor="#DDD9C3"></td>
                                  <td valign="top" bgcolor="#DDD9C3">
                                    <strong>
                                      {emissionsData.totalEmission} kgCO₂
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="row-report page-break">
                          <div className="col-md-12">
                            <div className="GreenBoxTitlees">CONCLUSION</div>
                            <div className="mainTxt">
                              <div
                                contentEditable
                                suppressContentEditableWarning={true}
                                className="editableParagraph"
                                onBlur={(e) =>
                                  setConclusionText(e.target.innerText)
                                }
                              >
                                {conclusionText ||
                                  `${
                                    eventDetails.eventName || "Event Name"
                                  } team has taken significant steps to minimize the event's carbon footprint, implementing various strategies such as energy-efficient venue selection, promoting sustainable transportation options, and reducing waste. Despite these efforts, a total of ${(
                                    totalEstimatedCarbonEmission / 1000
                                  ).toFixed(
                                    0
                                  )} carbon credits are required to fully offset the residual emissions from the event. By purchasing these carbon credits, the team aims to neutralize their environmental impact, supporting projects that reduce or remove an equivalent amount of greenhouse gases from the atmosphere. This commitment underscores the event's dedication to sustainability and decarbonization.`}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row-report page-break">
                          <div className="col-md-12">
                            <div className="report-buttons d-flex flex-row justify-content-end mt-4">
                              {/* <button className="btn GreenBtn" onClick={handleGenerateReport}>Generate Report</button> */}
                              <PreviewReport
                                eventDetails={eventDetails}
                                sproutImg={sproutImg}
                                uploadedLogo={uploadedLogo}
                                preEventData={preEventData}
                                duringEventData={duringEventData}
                                postEventData={postEventData}
                                totalEstimatedCarbonEmission={
                                  totalEstimatedCarbonEmission
                                }
                                attendeeTravelConsumptions={
                                  attendeeDetails.attendeeTravelConsumptions
                                }
                                attendeeMealConsumptions={
                                  attendeeDetails.attendeeMealConsumptions
                                }
                                attendeeDetails={attendeeDetails}
                                emissionsData={emissionsData}
                                image1={image1}
                                image2={image2}
                                image3={image3}
                                image4={image4}
                                image5={image5}
                                image6={image6}
                                image7={image7}
                                highlight1={highlight1}
                                highlight2={highlight2}
                                highlight3={highlight3}
                                highlight4={highlight4}
                                textContent1={textContent1}
                                textContent2={textContent2}
                                textContent3={textContent3}
                                textContent4={textContent4}
                                textContent5={textContent5}
                                textContent6={textContent6}
                              />
                              {/*<button
                                className="btn GreenButtonns ml-3 no-pdf"
                                onClick={handleDownloadPDF}
                              >
                                Download PDF
                              </button>
                              <button
                                className="btn GreenButton ml-3 no-pdf"
                                onClick={handleSave}
                              >
                                Save
                              </button> */}
                              <button
                                className="btn GreenButtonns ml-3 no-pdf"
                                onClick={handleDownloadWord}
                              >
                                Download Word
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showAlert && (
              <CustomAlert
                message={alertMessage}
                type={alertType}
                onClose={handleCloseAlert}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
